module.exports = require('./toPairs');



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706121922-6a92b31330-master/~/lodash/entries.js
// module id = 1073
// module chunks = 1